<template>
	<Header ref="header" v-if="from!=='baidu'&&from!=='H5'"/>
	<KjInfos ref="kjinfo" />
	
	<Tuijian ref="expertlist" v-if="from!=='baidu'&&from!=='H5'"/>
	<RJNewTuijian v-if="from==='H5'" ></RJNewTuijian>
</template>

<script>
	import Header from '@/components/Header'
	import KjInfos from '@/components/KjInfos'
	import Tuijian from '@/components/Tuijian'
	import RJNewTuijian from '@/components/RJNewTuijian'
	import { useRoute } from 'vue-router'
	import { provide,ref,onMounted } from 'vue'
	export default{
		name: 'Detail',
		components:{
			Header,
			KjInfos,
			Tuijian,
			RJNewTuijian
		},
		setup (){
			const expertlist = ref(null)
			const header = ref(null)
			const kjinfo = ref(null)
			const slide = ref(null)
			const { params:{issue,lotid}} = useRoute()
			let from = ''
			const route = useRoute()
			if(route.query.from&&route.query.from==='baidu'){
				from = 'baidu'
			}else if(route.query.from&&route.query.from==='H5'){
				from = 'H5'
			}else{
				window.location.href = 'http://t.zgzcw.com/module/hdH5/h5/index.html#/pages/lothall/Detail?sid=36001800018&lotid='+lotid+'&issue='+issue
			}
			provide('lottery',{issue,lotid})
			provide('from',from)
			onMounted(()=>{
				if(route.fullPath.indexOf('flag')>-1){
					setTimeout(()=>{
						window.scrollTo(0,header.value.$el.clientHeight+kjinfo.value.$el.clientHeight+slide.value.$el.clientHeight+10)
					},1000)
				}
				if(route.fullPath.indexOf('sid')>-1){
					const arrayurl = route.fullPath.split('?')
					let sidvalue = ''
					arrayurl.forEach((v,i)=>{
						if(v.indexOf('sid')>-1){
							sidvalue = v.split('=')[1]
							localStorage.newsid = sidvalue
						}
					})
				}
			})
			return { expertlist,header,kjinfo,slide,from,lotid }
		}
	}
</script>

<style scoped="">
	
</style>
